import { Button, Grid } from "antd";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { Input, SwitchButton } from "components/base";
import { setModalName, setZoneSearch } from "store/actions";
import { exportIcon, plusIcon, searchIcon } from "svgs";
import { ROUTES } from "utils/constants";
import { AppState } from "store";
import { AddZoneForm } from "../../forms";

import "styles/components/tab-headers/zones-header.scss";

const { useBreakpoint } = Grid;

export default function ZonesHeader() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const screens = useBreakpoint();

  // Determine screen size
  const isMobile = !screens.sm;
  const isTablet = screens.sm && !screens.lg;
  const isSmallMobile = !screens.xs;

  const selectedView = location.pathname.split("/")[2];
  const { showbulkActionsZones } = useSelector<AppState, AppState["zones"]>(
    (state) => state.zones
  );

  const onAddZone = () => {
    history.push(ROUTES.add_zone);
  };

  const onSwitchView = useCallback(
    (event) => {
      const { value } = event.target;
      history.push(`${ROUTES.zones}/${value}`);
    },
    [history]
  );

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setZoneSearch(event.target.value));
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(setZoneSearch(""));
  }, [dispatch]);

  const searchValue = useSelector<AppState, string>(
    (state) => state.zones.search || ""
  );

  // Get button text based on screen size
  const getButtonText = () => {
    if (isMobile) return null; // Icon only on mobile
    if (isTablet) {
      return (
        <span style={{ fontSize: '16px', fontWeight: 500, paddingLeft: '4px' }}>
          Add
        </span>
      );
    }
    return (
      <span style={{ fontSize: '16px', fontWeight: 500 ,paddingLeft: '4px'}}>
        Add Zone
      </span>
    );
  };

  // Get placeholder text based on screen size
  const getPlaceholder = () => {
    if (isMobile) return "Search...";
    return "Search Zones...";
  };

  return (
    <div className="zones-header">
      {/* Top Row - Search and Actions */}
      <div className={`header-row ${isSmallMobile ? "stacked" : ""}`}>
        {/* Search Input */}
        <div className="search-container">
          <Input
            customClasses="search-input"
            placeholder={getPlaceholder()}
            prefix={searchIcon}
            value={searchValue}
            onChange={onChange}
          />
        </div>

        {/* Bulk Actions */}
        {showbulkActionsZones && (
          <article className="bulk-actions">
            {/* Add bulk action buttons here if needed */}
          </article>
        )}

        {/* Actions Container */}
        <div className="actions-container">
          {/* View Switch */}
          <div className="switch-container">
            {!isMobile && (
              <span className="switch-label">Select View:</span>
            )}
            <SwitchButton
              options={["list", "map"]}
              defaultOption={selectedView ?? "list"}
              onChange={onSwitchView}
              type="secondary" label={""}            />
          </div>

          <div className="vertical-separator" />

          {/* Add Zone Button */}
          <Button
            type="primary"
            icon={<span className="btn-icon">{plusIcon}</span>}
            onClick={onAddZone}
            className="add-zone-btn"
          >
            {getButtonText()}
          </Button>
        </div>
       
      </div>
 {isMobile && ( <h1 style={{ flex: 1,paddingTop: "16px", alignItems: "left" }}>Zones</h1>)}
      {/* Mobile: View Switch Row (Optional - if you want it on separate row) */}
      {isSmallMobile && (
        <div className="mobile-switch-row">
          <span className="switch-label">View:</span>
          <SwitchButton
            options={["list", "map"]}
            defaultOption={selectedView ?? "list"}
            onChange={onSwitchView}
            type="secondary" label={""}          />
        </div>
      )}
    </div>
  );
}